module.exports = __webpack_public_path__ + "img/about4.149ec795.webp";